export const EquationGlobalVariable = () =>{
    return(
        <div className="container">
            <p>数式エディタのグローバル変数を示します</p>
            <img src={`${process.env.PUBLIC_URL}/equation_global_variable.png`}></img>
            <p>図の例では自分のライフを表しています。ターンカウントやチェーン数もあらわすことができます</p>
            </div>
    )
}
